import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import "../../moreCore/UI/Button/Button";
import "../../moreCore/UI/GenericDialog/GenericDialog";
import TicketApplicationForm from './TicketApplicationForm/TicketApplicationForm';
import FinderBaseV2 from '../FinderBase/FinderBaseV2';
import { TicketTypes } from "./TicketTypes";

class TicketFinderHome extends compose(FinderBaseV2) {
	//templateString = template;

    table_formatterFunction(cell: StaticTable.StaticTableCell<TicketTypes.TicketEntity>) {
        let colName = cell.name;
        let entity: TicketTypes.TicketEntity = <TicketTypes.TicketEntity>cell.entity;
        let value = cell.value;
        let node = cell.contentnode;

        switch (colName) {
            case "type":
                let contingent = entity.ref_vt_pos_ev_calc_ticket_contingent;

                node.innerHTML = value;
                node.innerHTML += " (" + contingent.tickets_applied + "/" + contingent.tickets_plan + ")";

                this.UiModder.domClass.toggle(node, "warningTXT", contingent.tickets_applied == contingent.tickets_plan);
                return true;
                break;
            case "address3": // anbefragt von
                if (entity.ref_address_3?.ID == this.getCurrentEmployeeId()) {
                    value = this.createFontawesomeIcon("fas fa-user", "&nbsp;").outerHTML + value;
                }
                node.innerHTML = value;
                return true;
                break;
            case "address1": // angefragt für
                if (entity.ref_address_1?.ID == this.getCurrentEmployeeId()) {
                    value = this.createFontawesomeIcon("fas fa-user", "&nbsp;").outerHTML + value;
                }

                if (entity.c_address_2) {
                    value += "<br>" + entity.c_address_2;
                }
                node.innerHTML = value;
                return true;
                break;

            case "tickets_applied":
            case "tickets_approved":
                this.UiModder.domClass.add(node, "w3-medium");
                if (entity[colName] > 0) {
                    if (entity.tickets_applied == entity.tickets_approved) {
                        this.UiModder.domClass.add(node, "bold");
                    }
                } else {
                    this.UiModder.domClass.add(node, "w3-opacity");
                }
                break;
            default:
                return false;
        }
    }

    private _onClick_Row(row: StaticTable.StaticTableRow<TicketTypes.TicketEntity>) {
        let entity = row.rowGroup.entity;
        this.openTicketForm(entity);
    }
    private openTicketForm(entity?: TicketTypes.TicketEntity) {
        let form = new TicketApplicationForm();
        form.on("saved", lang.hitch(this, this._onTicketRequestSaved));

        //dlg.setUserdefinedButton(this.translations["TicketFinder_saveDataButton_label"], "fas fa-save", lang.hitch(form, form.saveTicket), false);
        form.setContingent(entity.ref_vt_pos_ev_calc_ticket_contingent as any);

        if (entity) {
            form.setTicket(entity);
        }

        form.openInDlg();
    }

    private _onTicketRequestSaved() {
        this.reload();
    }
   
    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.setupFinderWithCallfunctions(
            "Webtool_API_TicketPool__GetFilterOptionsJSON",
            "Webtool_API_TicketPool__GetTicketsListJSON",
            lang.hitch(this, this._onClick_Row),
            lang.hitch(this, this.table_formatterFunction),
            null,
            [{
                name: "mode",
                value: "ticketfinder"
            }]
        );
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(TicketFinderHome);